import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import UserSettingsModal from '../UserSettingsModal';
import { IconButton } from './StandardButtons';

export default function UserProfileBand() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [showSettingsModal, setShowSettingsModal] = useState(false);

  // Default avatar - a nice gradient circle with user initial
  const getDefaultAvatar = () => {
    const initial = user?.username?.charAt(0).toUpperCase() || 'U';
    return (
      <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-blue-500 flex items-center justify-center font-semibold text-lg" style={{ color: 'var(--color-text-on-accent)' }}>
        {initial}
      </div>
    );
  };

  const handleSettingsClick = () => {
    setShowSettingsModal(true);
  };

  return (
    <div className="px-4 py-3 pr-12" style={{
      borderTop: '1px solid var(--color-border-default)',
      background: 'linear-gradient(135deg, var(--color-bg-tertiary), var(--color-bg-secondary))'
    }}>
      <div className="flex items-center gap-3">
        {/* Avatar */}
        <div className="flex-shrink-0">
          {user?.avatar_image ? (
            <img
              src={user.avatar_image}
              alt={user.username}
              className="w-10 h-10 rounded-full object-cover"
              style={{ border: '2px solid var(--color-border-default)' }}
            />
          ) : user?.avatar_url ? (
            <img
              src={user.avatar_url}
              alt={user.username}
              className="w-10 h-10 rounded-full object-cover"
              style={{ border: '2px solid var(--color-border-default)' }}
            />
          ) : (
            getDefaultAvatar()
          )}
        </div>

        {/* Username */}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium truncate" style={{ color: 'var(--color-text-primary)' }}>
            {user?.username || 'User'}
          </p>
          <p className="text-xs" style={{ color: 'var(--color-text-muted)' }}>
            {user?.permissions?.includes('admin_access')
              ? 'Admin'
              : user?.roles && user.roles.length > 0
              ? user.roles.join(', ')
              : 'User'}
          </p>
        </div>

        {/* Settings Button */}
        <IconButton onClick={handleSettingsClick} title="Settings" className="-mt-1">
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </IconButton>
      </div>

      {/* User Settings Modal */}
      <UserSettingsModal
        isOpen={showSettingsModal}
        onClose={() => setShowSettingsModal(false)}
      />
    </div>
  );
}
